import { AppPermissions } from 'constants/permissions';

export const permissions = {
  addItem: [AppPermissions.add_category],
  editItem: [AppPermissions.change_category],
  deleteItem: [AppPermissions.delete_category],
  viewDeficiencyItems: [AppPermissions.view_deficiencyitems],
  editDeficiencyItems: [AppPermissions.change_deficiencyitems],
};
